import React from "react";
import { Underline, Floatinmenu, Backtotop } from "../../widgets";
import { useEffect } from "react";
import {
  board_members,
  incubation_img_corousal,
  core_team,
  incubation_menu,
} from "../../constants/incubation";
import { Heroimagecarousal, Profile_display } from "../../components";
import "./Incubation.css";
import { FaComputer } from "react-icons/fa6";

import { RadialMenu } from "../../components";

const Board_members = () => {
  useEffect(() => {
    document.title = "ACCET-Incubation | Board Members";
  }, []);
  return (
    <div className="nssboardmembers">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />
      <section className="ecedark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
        </div>
        <RadialMenu menu_links={incubation_menu} />
        <div className="ece_fac_area">
          <div className="ece_teach_fac">
            <Underline heading="BOARD DIRECTORS" />
            <Profile_display list_info={board_members} />
          </div>
          <div className="ece_teach_fac">
            <Underline heading="CORE TEAM" />
            <Profile_display list_info={core_team} />
          </div>
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default Board_members;
